var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "dashboard-container" } }, [
    _c("div", { staticClass: "is-flex is-flex-wrap-wrap" }, [
      _c("iframe", {
        staticClass: "mr-4",
        attrs: {
          src: "https://lottie.host/embed/0286bf2e-3fe9-41d8-b2bf-31980e4f7f00/2l7cMPA4xO.json",
          width: "200",
        },
      }),
      _c("div", { staticClass: "is-flex is-flex-direction-column" }, [
        _c("h1", [
          _c(
            "span",
            {
              staticClass: "is-size-2 has-text-primary has-text-weight-medium",
            },
            [_vm._v(_vm._s(_vm.$t("hello")) + " ")]
          ),
          _c("span", { staticClass: "is-size-2" }, [
            _vm._v(
              _vm._s(_vm.$store?.state?.currentUser?.user?.name || "") + "!"
            ),
          ]),
        ]),
        _vm.$store?.state?.currentUser?.user?.rol === "CLIENT"
          ? _c("span", [
              _vm.welcomeDate.type === "MORTGAGE"
                ? _c("p", { staticClass: "has-text-grey" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.welcomeDate.years === false &&
                            _vm.welcomeDate.months === false
                            ? _vm.$t("ownedSinceDays")
                            : _vm.$t("ownedSince")
                        ) +
                        " " +
                        _vm._s(
                          _vm.welcomeDate.years && _vm.welcomeDate.years == 1
                            ? _vm.welcomeDate.years + _vm.$t("singleYear")
                            : _vm.welcomeDate.years === false
                            ? ""
                            : _vm.welcomeDate.years + _vm.$t("pluralYear")
                        ) +
                        _vm._s(
                          _vm.welcomeDate.years !== false &&
                            _vm.welcomeDate.months !== false
                            ? _vm.$t("and")
                            : ""
                        ) +
                        " " +
                        _vm._s(
                          _vm.welcomeDate.months && _vm.welcomeDate.months == 1
                            ? _vm.welcomeDate.months + _vm.$t("singleMonth")
                            : _vm.welcomeDate.months === false
                            ? ""
                            : _vm.welcomeDate.months + _vm.$t("pluralMonth")
                        ) +
                        " "
                    ),
                  ])
                : _vm.welcomeDate.type === "SME"
                ? _c("p", { staticClass: "has-text-grey" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.welcomeDate.years === false &&
                            _vm.welcomeDate.months === false
                            ? _vm.$t("ownedSinceDaysSME")
                            : _vm.$t("ownedSinceSME")
                        ) +
                        " " +
                        _vm._s(
                          _vm.welcomeDate.years && _vm.welcomeDate.years == 1
                            ? _vm.welcomeDate.years + _vm.$t("singleYear")
                            : _vm.welcomeDate.years === false
                            ? ""
                            : _vm.welcomeDate.years + _vm.$t("pluralYear")
                        ) +
                        _vm._s(
                          _vm.welcomeDate.years !== false &&
                            _vm.welcomeDate.months !== false
                            ? _vm.$t("and")
                            : ""
                        ) +
                        " " +
                        _vm._s(
                          _vm.welcomeDate.months && _vm.welcomeDate.months == 1
                            ? _vm.welcomeDate.months + _vm.$t("singleMonth")
                            : _vm.welcomeDate.months === false
                            ? ""
                            : _vm.welcomeDate.months + _vm.$t("pluralMonth")
                        ) +
                        " "
                    ),
                  ])
                : _vm.welcomeDate.type === "PARKING"
                ? _c("p", { staticClass: "has-text-grey" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.welcomeDate.years === false &&
                            _vm.welcomeDate.months === false
                            ? _vm.$t("ownedSinceDaysParking")
                            : _vm.$t("ownedSinceParking")
                        ) +
                        " " +
                        _vm._s(
                          _vm.welcomeDate.years && _vm.welcomeDate.years == 1
                            ? _vm.welcomeDate.years + _vm.$t("singleYear")
                            : _vm.welcomeDate.years === false
                            ? ""
                            : _vm.welcomeDate.years + _vm.$t("pluralYear")
                        ) +
                        _vm._s(
                          _vm.welcomeDate.years !== false &&
                            _vm.welcomeDate.months !== false
                            ? _vm.$t("and")
                            : ""
                        ) +
                        " " +
                        _vm._s(
                          _vm.welcomeDate.months && _vm.welcomeDate.months == 1
                            ? _vm.welcomeDate.months + _vm.$t("singleMonth")
                            : _vm.welcomeDate.months === false
                            ? ""
                            : _vm.welcomeDate.months + _vm.$t("pluralMonth")
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ])
          : _c("p", { staticClass: "has-text-grey" }, [
              _vm._v(_vm._s(_vm.$t("lastNewsMessage"))),
            ]),
      ]),
    ]),
    _c("div", { staticClass: "columns is-multiline mt-4" }, [
      _c("div", { staticClass: "column is-4-widescreen is-full" }, [
        _vm.$i18n.locale == "br"
          ? _c("div", { staticClass: "card-item" }, [
              _c("span", { staticClass: "is-flex is-align-items-center" }, [
                _vm._m(0),
                _c("span", [
                  _c("h4", { staticClass: "has-text-grey is-size-6" }, [
                    _vm._v(_vm._s(_vm.formattedTodayDate)),
                  ]),
                ]),
              ]),
            ])
          : _c("div", { staticClass: "card-item" }, [
              _c("span", { staticClass: "is-flex" }, [
                _vm._m(1),
                _c("span", [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "has-text-grey has-text-weight-medium is-size-6",
                    },
                    [_vm._v(_vm._s(_vm.formattedTodayDate))]
                  ),
                ]),
              ]),
            ]),
      ]),
      _c("div", { staticClass: "column is-3-widescreen is-full" }, [
        _vm.$i18n.locale !== "pe"
          ? _c("div", { staticClass: "card-item" }, [
              _c("span", { staticClass: "is-flex" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "icon-item is-flex is-align-items-center is-justify-content-center",
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "has-text-primary has-text-weight-semibold",
                      },
                      [_vm._v(_vm._s(_vm.$t("localeIndicator")))]
                    ),
                  ]
                ),
                _c("span", [
                  _vm.$i18n.locale == "br"
                    ? _c(
                        "h4",
                        {
                          staticClass:
                            "has-text-grey has-text-weight-medium is-size-6",
                        },
                        [_vm._v(_vm._s(_vm.indicators.ipca))]
                      )
                    : _vm._e(),
                  _vm.$i18n.locale == "cl"
                    ? _c(
                        "h4",
                        {
                          staticClass:
                            "has-text-grey has-text-weight-medium is-size-6",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              `$${_vm.setValueToFormatted(
                                _vm.indicators.uf,
                                "currencyNumber"
                              )}`
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.$store?.state?.currentUser?.user?.rol === "CLIENT"
        ? _c("div", { staticClass: "column" }, [
            _c(
              "div",
              [_c("CreditResume", { attrs: { "show-resume": true } })],
              1
            ),
          ])
        : _c("div", { staticClass: "column" }, [
            _c("div", [_c("product-doings")], 1),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "icon-item is-flex is-align-items-center is-justify-content-center",
      },
      [
        _c("i", {
          staticClass: "fa-regular fa-calendar has-text-primary is-size-5",
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "icon-item is-flex is-align-items-center is-justify-content-center",
      },
      [
        _c("i", {
          staticClass: "fa-regular fa-calendar has-text-primary is-size-5",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }